<div
  class="flex items-center p-4 my-4 border-l-4 text-yellow-700 bg-yellow-50 border-yellow-700"
  role="alert"
>
  <pulse-icon [icon]='icon'></pulse-icon>
  <div class="pl-2 text-sm font-medium">{{ text}}</div>
</div>
